export type ThemeConfigTypes = 'size' | 'color' | 'spacing';
export type ThemeConfigUnits = 'px' | 'rem';

export type ThemeConfig = {
    name: string;
    label: string;
    type: ThemeConfigTypes;
    defaultValue?: string | number;
    minValue?: number;
    maxValue?: number;
    unit?: ThemeConfigUnits;
}

const generateThemeInlineCss = (config: ThemeConfig[], values: Record<string, any>) => config.reduce((acc, configEntry) => {
    let newValue: string;
    switch (configEntry.type) {
        case 'size':
            newValue = `${acc} --${configEntry.name}: ${values[configEntry.name] || configEntry.defaultValue}${configEntry?.unit};`;
            break;
        case 'color':
            newValue = `${acc} --${configEntry.name}: ${values[configEntry.name] || configEntry.defaultValue};`;
            break;
        default:
            newValue = acc;
    }
    return newValue;
}, '');

export default generateThemeInlineCss;
